import { Chip, Tooltip } from "@mui/material";

import { getSupplierColor, getSupplierInitial } from "../utils/supplierColors";

export const SupplierChip = ({ value }: { value?: string | null }) => {
	if (!value) return null;

	return (
		<Tooltip title={value} arrow>
			<Chip
				label={getSupplierInitial(value)}
				size="small"
				sx={{
					bgcolor: getSupplierColor(value),
					color: "#fff",
					fontWeight: 700,
					fontSize: "0.65rem",
					height: 20,
					width: 20,
					flexShrink: 0,
					borderRadius: 0.75,
					"& .MuiChip-label": { px: 0 },
				}}
			/>
		</Tooltip>
	);
};
